export default __webpack_public_path__ + "static/media/grey-checkbox.a958cae6.svg";